import { useEffect, useRef, useState } from 'react'
import {
	hasSupport,
	updatePositioningWithLib
} from 'shared/polyfills/positioning'

import css from './MessageActions.module.scss'
import { menu, openId } from './utils'
export function useOpened(id = '') {
	const triggerRef = useRef<HTMLDivElement | null>(null)
	const [isOpen, setIsOpen] = useState(false)

	useEffect(() => {
		const controller = new AbortController()

		controller.signal.addEventListener('abort', () => setIsOpen(false), {
			once: true
		})

		openId.subscribe(() => {
			const isSame = id === openId.value

			if (hasSupport) {
				setIsOpen(isSame)
			} else {
				if (!isSame && menu && triggerRef.current) {
					updatePositioningWithLib(triggerRef.current, menu).then(
						unsubscribe => {
							controller.signal.addEventListener('abort', unsubscribe, {
								once: true
							})
						}
					)
				}
			}
		}, controller.signal)

		return () => {
			controller.abort()
		}
	}, [id])

	return {
		isOpen,
		openClass: isOpen && css.currentAnchor,
		triggerRef
	}
}
